import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router';
import HeaderComponent from './components/HeaderComponent';
import BreadCrumbs from './components/BreadCrumbs';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

// project imports
import { DIALOG_ACTIVE, SET_MENU, SET_PERMISSIONS } from '../constants/actions';

// assets
import SidebarComponent from './components/SidebarComponent';
import useCustomizeTheme from 'hooks/useCustomizeTheme';
import useConfiguration from 'hooks/useConfiguration';
import useAwaitDialog from 'hooks/useAwaitDialog';
import { ErrorFooter, ErrorForm, ErrorHeader } from 'components/general/DialogSessionError';
import pathMenus from 'menu-items/pathMenus';

const MainLayout = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { execute } = useAwaitDialog()
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const { isOpen, opened } = useSelector((state: any) => state.customization)
    const { handleChangeTheme } = useCustomizeTheme()
    const { handleConfiguration } = useConfiguration()
    const pathName = window?.location?.pathname
    const menus = global.session?.role.menu_access
    const [menuIsValid, setMenuIsValid] = useState(true)
    const [breadcrumbsTitle, setBreadcrumbsTitle] = useState('')
    useMemo(() => {
        handleChangeTheme(localStorage.getItem('theme') ?? 'white')
        handleConfiguration(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config') as string) : {})
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // Handle left drawer
    useEffect(() => {
        dispatch({ type: SET_MENU, opened: !matchDownMd });
    }, [matchDownMd]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const _permission = global.session?.role?.endpoint_access?.filter((a: any) => a.MenuRefer === isOpen[0])
        dispatch({ type: SET_PERMISSIONS, payload: _permission })
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        checkMatchingPath()
    }, [pathName])

    const checkMatchingPath = async () => {
        let dbMenus = menus?.map(menu => menu?.url);
        let newMenus = pathMenus?.filter(el => dbMenus.indexOf(el?.url_id) !== -1);
        const childData = await newMenus?.find((menu) => {
            return pathName?.includes(menu?.url_path)
        });
        if (!childData) {
            setMenuIsValid(false)
            dispatch({ type: DIALOG_ACTIVE, dialogCustomization: { childrenVar: [<ErrorHeader slot='dialog-header' title='Akses Terbatas' />, <ErrorForm slot='dialog-body' message='Tidak ada akses yang tersedia untuk anda saat ini. Silahkan menghubungi administrator untuk mendapatkan akses.' />, <ErrorFooter slot="dialog-footer" />], dialogImage: 'error' } })
            const confirm = await execute()
            if (confirm)
                navigate(-1)
            return
        }
        setMenuIsValid(true)
    }

    return (
        <div className="flex">
            <HeaderComponent />
            {
                menuIsValid ?
                    <div className="flex w-full">
                        <SidebarComponent />
                        <div className={"w-full sm:p-[16px] md:p-[20px] p-[16px] pt-[30px] bg-primary-main bg-opacity-50 min-h-[calc(100vh_-_5rem)] mt-[5rem] " + (opened ? 'md:ml-0 lg:ml-[16rem]' : '')}>
                            <BreadCrumbs title={breadcrumbsTitle} />
                            <div className="py-2"></div>
                            <div className="z-0">
                                <Outlet context={[setBreadcrumbsTitle]} />
                            </div>
                        </div>
                    </div>
                    : null
            }
        </div>
    );
};

export default MainLayout;
